export const API_KEY = 'DS9YKV8Tn7ba42IoXk20tS381cnGUKXR'

export const API_URL = 'https://api.giphy.com/v1'